export const ROLES = ["it", "scada", "pio", "soc", "admin"];

export const ROLE_CODES = {
  it: "computers-are-cool",
  scada: "all-about-control",
  pio: "i-serve-the-public",
  soc: "close-that-firewall",
  admin: "god-mode"
};

export const ROLE_MAP = {
  "SCADA Technician": "scada",
  "System Administrator": "it",
  "Public Information Officer": "pio",
  "Security Analyst": "soc"
};

export const REVERSE_ROLE_ABBR_MAP = {
  // abbreviation map between old and new system
  "scada": "SCADA",
  "it": "SysAdmin",
  "pio": "PIO",
  "soc": "SOC"
};

export const REVERSE_ROLE_MAP = {
  "scada": "SCADA Technician",
  "it": "System Administrator",
  "pio": "Public Information Officer",
  "soc": "Security Analyst"
};


export const WORKER_STATUSES = {
  BUSY: "busy",
  AVAILABLE: "available",
  UNAVAILABLE: "unavailable"
};

export const BUSY_TIMEOUT = 5000;

// node status
export const NODE_HEALTHY = "healthy";
export const NODE_UNKNOWN = "unknown";
export const NODE_COMPROMISED = "compromised";
export const NODE_OFF = "off";

export const NODE_STATUS_PRIORITY = {
  [NODE_COMPROMISED]: 4,
  [NODE_UNKNOWN]: 3,
  [NODE_OFF]: 2,
  [NODE_HEALTHY]: 1
};

// time for rounds in minutes
export const DEFAULT_ROUND_TIMER_MINS = 5;
export const DEFAULT_BREAK_TIMER_MINS = 2;
// add custom round timers here
export const ROUND_TIMERS = {
  1: 5,
  2: 7,
  3: 7,
  4: 5
};
export const COMMUNITY_COST_MAP = {
  1: "Extremely Low (1 out of 9)",
  2: "Very Low (2 out of 9)",
  3: "Low (3 out of 9)",
  4: "Moderately Low (4 out of 9)",
  5: "Moderate (5 out of 9)",
  6: "Moderately High (6 out of 9)",
  7: "High (7 out of 9)",
  8: "Very High (8 out of 9)",
  9: "Extremely High (9 out of 9)"
}
export const CONTRACTORS = {
  it: [
    {
      name: "Angel",
      description:
        "Angel Montgomery – A tech trained at State University at Bronze Falls (SUBF), Montgomery generally manages the City’s hardware and software challenges; she loves professional football."
    },
    {
      name: "Billy",
      description:
        "Billy Johnson – An administrator with 30 years service in Bronze Falls, Johnson is a grumpy administrative staff member with a dour look on life."
    },
    {
      name: "Cecil",
      description:
        "Cecil Bean – New to Bronze Falls having moved from Atlanta, Georgia, Bean is eager and enthusiastic, and dreams of being a web designer.  Hired to do general administrative support."
    },
    { name: "Kimberley", description: "" }
  ],
  soc: [
    {
      name: "Frances",
      description:
        "Frances MacSalle – Assigned from the Bronze Falls Volunteer Fire Department, MacSalle is the liaison to EMTs and firefighters; she generally specializes in logistics."
    },
    {
      name: "Earl",
      description:
        "Earl Loomis – Detailed from the Bronze Falls Police Department communications center, Loomis is small in stature but quite officious and talkative."
    },
    {
      name: "Mattie",
      description:
        "Mattie David – Brought in from the Bronze Falls Memorial Hospital, David is a veteran of years of service in the Emergency Room intake; has deadpan sense of humor."
    },
    { name: "Cora", description: "" }
  ],
  pio: [
    {
      name: "Lula",
      description:
        "Lula Davies – Hired by Luisa Flores out of SUBF, Davies wrote for the student paper, and helped write the student play Bronze Falls But Gets Back Up.  She is cynical."
    },
    {
      name: "Rose",
      description:
        "Rose Harrington – Also hired by Flores out of SUBF, Fischer was a leader in the news division of the campus radio station.  Works for the City, with a podcast on the side."
    },
    {
      name: "Rhonda",
      description:
        "Rhonda Harper – A talkative veteran of the public information office, Harper preceded Flores and recalls the days when most of her work was writing press releases and getting them out."
    },
    { name: "Ramona", description: "" }
  ],
  scada: [
    {
      name: "Camille",
      description:
        "Camille Parker - Quiet and determined, and another SUBF grad.  Parker grew up in River Bottom, in the southwest side of town."
    },
    {
      name: "Johnathan",
      description:
        "Johnathan Summers – From out of state with an engineering background, Summers has worked for Bronze Falls for two years; sometimes goes hunting and fishing with Grant Fisher."
    },
    {
      name: "Clifton",
      description:
        "Clifton Anthony – A theatrical math wizard out of SUBF, Anthony is interested in cybersecurity and graphic novels.  Binge watched Game of Thrones; awesome with code."
    },
    { name: "Henrietta", description: "" }
  ]
};


export const EXPERT_HINTS = {
  it: [
    {
      name: "Modo",
      hint:
        "Us here on the IT team have visibility into the status of computers and servers of the Bronze Falls Network. Pretty cool, right? But we can’t see SCADA devices, so be sure you collaborate with the SCADA person for more info on those devices."
    },
    {
      name: "Modo",
      hint:
        "If you find an infected device I want you to shut it off immediately. We don’t want to risk any exposure to the rest of the systems. You don’t want your device files to become corrupted either. Always best to shut the thing down. Make sure you have access to secure backups though. They’ll help you when you rebuild your system."
    },
    {
      name: "Modo",
      hint:
        "It’s up to you to manage and defend the Bronze Falls IT systems. You’re the one who can see how much a device has been damaged if it’s been infected or taken offline, so share that info with your team."
    }
  ],
  scada: [
    {
      name: "Grant",
      hint:
        "Your job is to understand the impact on the community of SCADA systems outages. You need to share information with others to make sure everything runs smoothly."
    },
    {
      name: "Grant",
      hint:
        "There are many different critical infrastructures hackers can choose to take control over. Things like a dam or a transformer substation. But remember, if a hacker controls a smaller device they can still turn the system against itself. Take Johannesburg for example. Hackers had prevented the billing system from registering payments that the citizens were making. This caused thousands to lose power because the system registered citizens as being delinquent on payments. We don’t want that in Bronze Falls. That wouldn’t happen if I was in charge."
    },
    {
      name: "Grant",
      hint:
        "When deciding to shut off critical systems, keep in mind that the cost can be very high. Our goal is zero downtime."
    }
  ],
  pio: [
    {
      name: "Luisa",
      hint:
        "Keep in mind that you don’t see all of the technical details of individual devices, or the connections between them.  You CAN see, and will need to communicate the cost of the community impact, if and when devices are shut off . You are also the only one who can notify people about issues."
    },
    {
      name: "Luisa",
      hint:
        "The ability to keep the public informed of what is happening during a crisis is critical. If people aren’t kept up-to-date, the social costs include a reduction of trust in government, likely to have a high impact on the success of the Smart Bronze Falls Initiative, not to mention the future of Bronze Falls.  Keep in mind, though, that if the public is notified about things that aren’t  significant, people will not appreciate the waste of their time."
    },
    {
      name: "Luisa",
      hint:
        "Your input on where problems are occurring is important; not everyone can see all the devices in the system like you can.  Data evident to you should be cross-referenced with information from other players about device connections to get a bigger picture on any attack."
    }
  ],
  soc: [
    {
      name: "Hopper",
      hint:
        "You’re one of the first responders in our SOC: you are the only Junior Associate who has a city-wide view of our information systems, their connections to each other, and to networks outside Bronze Falls. You’re also the only one who can disconnect systems, if and when it’s necessary."
    },
    {
      name: "Hopper",
      hint:
        "Don’t forget: just because you’ve found one issue doesn’t mean it’s the only one. Experienced hackers can attack us on multiple fronts. They can distract you with one thing while sneaking into our systems another way."
    },
    {
      name: "Hopper",
      hint:
        "Monitor your systems for any odd behavior at all times. If you see traffic increasing between two devices, that could mean one device is infected or otherwise compromised. The extra traffic could mean that the device is sending private data to -- or receiving commands from -- an attacker. Be vigilant for anomalous behavior like this."
    }
  ]
};